import Banner from "../Components/Shared/Layout/Banner";
import withLanguage from "../HOC/withLanguage";
import YoutubeEmbed from "../Components/Shared/Layout/YoutubeEmbed";
import VideoInfoGrid from "../Components/Shared/Layout/VideoInfoGrid";

const AftesiNdryshe = ({ language }) => {
    const content = {
        bannerTitle: "Arsimi Profesional për Personat me Aftësi Ndryshe",
        introParagraph: `Arsimi profesional në Shqipëri ofron akses në studime për Personat me Aftësi të Kufizuara, duke përshtatur ambientet mësimore dhe duke ofruar mbështetje specifike nga mësues ndihmës të trajnuar posaçërisht për këtë kategori. Gjatë gjithë periudhës së studimit, këta nxënës jo vetëm që ruajnë përfitimet financiare të përcaktuara për Aftësinë e Kufizuar, por përfitojnë edhe bursa studimore.`,
        legalIntro: `Për tu njohur me shumë me përfitimet shfletoni bazën ligjore:`,
        secondParagraph: `Personat me aftësi të kufizuara gjejnë mbështetje, kushte të përshtatshme dhe mundësi reale për të ndërtuar një karrierë të qëndrueshme. Në arsim profesional, të gjithë janë të barabartë.`,
        story1: `ANA, pas përfundimit me sukses të arsimit profesional, dega ekonomi arriti të punësohet menjëherë në profilin për të cilin ....`,
        story2: `ANA, pas përfundimit me sukses të arsimit profesional, dega ekonomi arriti të punësohet menjëherë në profilin për të cilin ....`,
    };

    return (
        <>
            <Banner img='/AftesiNdryshe/banner.jpg' title={content.bannerTitle} />

            <div className="container mx-auto px-6 py-12 text-gray-800">

                <p className="text-lg leading-relaxed mb-8">
                    {content.introParagraph}
                </p>

                <div className="mb-12">
                    <p className="mb-4 font-semibold">{content.legalIntro}</p>
                    <div className="flex flex-col sm:flex-row flex-wrap gap-4">
                        <button className="bg-red-600 text-white font-bold py-3 px-10 rounded hover:bg-red-700 transition-colors grow text-center">
                            VKM BURSAVE
                        </button>
                        <button className="bg-red-600 text-white font-bold py-3 px-10 rounded hover:bg-red-700 transition-colors grow text-center">
                            UDHEZIM MESUES NDIHMES
                        </button>
                        <button className="bg-red-600 text-white font-bold py-3 px-10 rounded hover:bg-red-700 transition-colors grow text-center">
                            VKM TRANSPORTI
                        </button>
                    </div>
                </div>

                <p className="text-lg leading-relaxed mb-8">
                    {content.secondParagraph}
                </p>

                <VideoInfoGrid apiPath="aftesi_te_kufizuar" />

            </div>
        </>
    );
};
export default withLanguage(AftesiNdryshe, "SpecialAbilities");